// import color from "../../../constants/color";

import color from "../../../../../constants/color";

const styles = {
  heading: {
    fontSize: "20px",
    fontWeight: "600",
    // pl:2
  },
  gridContainer: {
    px: "15px",
    pt: "7px",
    py: 1,
    display: "flex",
    justifyContent: "space-between",
    mt: 2
  },
  inputGrid: {
    mr: 1,
    width: { xs: "100%", md: "50%" }
  },
  inputGrids: {
    width: { xs: "100%", md: "50%" }
  },

  reason: {
    borderRadius: "8px",

    width: "100%",
    mt: 1,
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      py: 1
    },
  },

  graph: {
    " & svg": {
      width: "100%"
    }
  },
  reportHeading: {
    fontSize: "18px",
    fontWeight: "600",
    mb: 2
  },
  purchase: {
    fontSize: "12px",
    fontWeight: "400",

  },
  grid: {
    display: "flex",
    mt: 1
  },
  keySec: {
    width: "50%",
  },
  key: {
    fontSize: "14px",
    fontWeight: "500",
    color: color.lightText
  },
  value: {
    fontSize: "20px",
    fontWeight: "500",
    color: color.text
  },

  gridbox: {
    // alignItems:"center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: 2,
    mb: { xs: 2, md: 2, lg: 0 },
    // justifyContent: "space-between",
  },
  greenDot: {
    backgroundColor: color.primary,
    height: "12px",
    width: "12px",
    borderRadius: "50%",
    mr: 1,
    mt: "4px"
  },

  TableHead: {
    color: color.lightText,
    fontWeight: "400",
    whiteSpace: "nowrap",
    overflow: "hidden", 

  },
  tabledata: {
    borderBottom: 0,
    whiteSpace: "nowrap",
    overflow: "hidden", 
  },
  tableAvtardata: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
  },

  tableActiondata: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-between", 
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text
  },
  // deleteIcon: {
  //   color:"#ff0000"
  // },
  input: {
    width: "100%",
    borderRadius: "8px",
    my: 1,
    height: "2.5em",
    marginBottom: "1em"
  },
  space: {
    my: 2
  },
  modalInput: {
    display: "flex",    // backgroundColor:color.lightGray,
    // width:{ xs: "25em", md: "35em" },
    justifyContent: "center",// Center align on smaller screens
    my: "10px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px"
    },
    "& .MuiOutlinedInput-root": {
      padding: "0"
    },
    "& .css-dnmsqw-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px"
    },
  },
  inputSpace: {
    "& .MuiOutlinedInput-root": {
      padding: "0px 14px"
    },

  },
  calenderInput: {
    "& .MuiInputBase-input": {
      padding: "8.5px 14px"
    }
  },
  noteInput: {
    height: "4.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "14px"
    },
  },
  calender: {
    borderRadius: "5px",
  },
  statusFilter: {
    position: "fixed",
    py: 1,
    px: 2
  },
  filterText: {
    fontSize: "12px",
    fontWeight: "500",
    mr: "2em"
  },
  width: {
    mr: { xs: 0, md: "7px" }
  },
  widths: {
    // mr:{xs:0, md:2}
  },

  containerInput: {
    display: { sx: "block", md: "flex" },
    // flexDirection:"row"
  },
  fromTogrid: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  statusBtn:
    {
      border: "1px solid #28AA4A ",
      borderRadius: "10px",
      ml: 5,
      mx: { xs: "20px" },
      mt: { xs: "15px", sm: "5px" },
      width: "fit-content",
    },
  name: {
    color: color.text,
    whiteSpace: "nowrap",
    overflow: "hidden", 
    fontSize: "14px",
    fontWeight: "400",
    textTransform: "capitalize"

  },
  mail: {
    color: color.lightText,
    fontSize: "14px",
    fontWeight: "400"
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    pl: 4
  },
  checkinBtn:
    {
      borderRadius: 50,
      backgroundColor: color.secondary,
      color: "#fff",
      ml: "8px",
      textTransform: "none",
      fontSize: "12px",
      boxShadow: "none"

    },
  checkoutBtn: {
    borderRadius: 50,
    backgroundColor: "#28AA4A",
    color: "#fff",
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none"
  },
  exportbtn: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: color.secondary,
    // mr: "10px", 
    // my: 4,
    alignItems: "center",
    fontSize: "12px",
    px: 3,

  },
  viewIcon: {
    color: color.lightText,
    fontSize: "1.3rem",
    mx: 2
  },
  emailIcon: {
    mr: 1,
    fontSize: "0px"
  },
  projectContainer: {
    // display: {xs:"block", md: "flex"},
    alignItems: "end",
    gap: "20px",
    my: 1
  },
  labels: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: "10px"
  },

  hoursInput: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",

    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",

    },

  },

  addIcon: {
    p: 1,
    pb: 0,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary
  },
  deleteIcon: {
    p: 1,
    pb: 0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red

  },
  exportBtn: {
    borderRadius: 50,
    color: color.secondary,
    border: "1px solid #00ABF4",
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none",
    py: "4px",
    px: "8px",
    "& svg": {
      mr: 1
    }
  }



};
export default styles;